import { URL_CONFIG } from '@source/constants/urlConfig';
import { TLanguageKey } from '@source/interface';

import InspectionIcon from './assets/as-is-160-point.svg';
import NoAccidentsIcon from './assets/as-is-no-accidents.svg';

// eslint-disable-next-line import/prefer-default-export
export const CARRO_AS_IS_CONTENT = (lang: TLanguageKey) => ({
  sg: {
    sectionTitle: 'shared.asIs.my.banner.sectionTitle',
    sectionTitleMobile: 'shared.asIs.my.banner.sectionTitleMobile',
    title: 'shared.asIs.my.banner.title',
    subTitle: {
      desktop: 'shared.asIs.my.banner.subTitle',
      mobile: 'shared.asIs.my.banner.subTitleMobile',
      tablet: 'shared.asIs.my.banner.subTitleTablet',
    },
    extraInfo: {
      desktop: 'shared.asIs.my.banner.extraInfo',
      mobile: 'shared.asIs.my.banner.extraInfoMobile',
      tablet: 'shared.asIs.my.banner.extraInfoTablet',
    },
    body: [
      {
        key: 'inspection',
        text: {
          desktop: 'shared.asIs.my.banner.pointInspectionDesktop',
          mobile: 'shared.asIs.my.banner.pointInspectionMobile',
        },
        icon: {
          desktop: InspectionIcon,
          mobile: null,
        },
      },
      {
        key: 'damage',
        text: {
          desktop: 'shared.asIs.my.banner.noMajorAccidentDesktop',
          mobile: 'shared.asIs.my.banner.noMajorAccidentMobile',
        },
        icon: {
          desktop: NoAccidentsIcon,
          mobile: null,
        },
      },
    ],
    // linkUrl: URL_CONFIG({ region: 'my', lang, path: 'carro-certified' }).formatted,
    linkUrl: '/',
  },
  id: {
    sectionTitle: 'shared.asIs.my.banner.sectionTitle',
    sectionTitleMobile: 'shared.asIs.my.banner.sectionTitleMobile',
    title: 'shared.asIs.my.banner.title',
    subTitle: {
      desktop: 'shared.asIs.my.banner.subTitle',
      mobile: 'shared.asIs.my.banner.subTitleMobile',
      tablet: 'shared.asIs.my.banner.subTitleTablet',
    },
    extraInfo: {
      desktop: 'shared.asIs.my.banner.extraInfo',
      mobile: 'shared.asIs.my.banner.extraInfoMobile',
      tablet: 'shared.asIs.my.banner.extraInfoTablet',
    },
    body: [
      {
        key: 'inspection',
        text: {
          desktop: 'shared.asIs.my.banner.pointInspectionDesktop',
          mobile: 'shared.asIs.my.banner.pointInspectionMobile',
        },
        icon: {
          desktop: InspectionIcon,
          mobile: null,
        },
      },
      {
        key: 'damage',
        text: {
          desktop: 'shared.asIs.my.banner.noMajorAccidentDesktop',
          mobile: 'shared.asIs.my.banner.noMajorAccidentMobile',
        },
        icon: {
          desktop: NoAccidentsIcon,
          mobile: null,
        },
      },
    ],
    // linkUrl: URL_CONFIG({ region: 'my', lang, path: 'carro-certified' }).formatted,
    linkUrl: '/',
  },
  th: {
    sectionTitle: 'shared.asIs.my.banner.sectionTitle',
    sectionTitleMobile: 'shared.asIs.my.banner.sectionTitleMobile',
    title: 'shared.asIs.my.banner.title',
    subTitle: {
      desktop: 'shared.asIs.my.banner.subTitle',
      mobile: 'shared.asIs.my.banner.subTitleMobile',
      tablet: 'shared.asIs.my.banner.subTitleTablet',
    },
    extraInfo: {
      desktop: 'shared.asIs.my.banner.extraInfo',
      mobile: 'shared.asIs.my.banner.extraInfoMobile',
      tablet: 'shared.asIs.my.banner.extraInfoTablet',
    },
    body: [
      {
        key: 'inspection',
        text: {
          desktop: 'shared.asIs.my.banner.pointInspectionDesktop',
          mobile: 'shared.asIs.my.banner.pointInspectionMobile',
        },
        icon: {
          desktop: InspectionIcon,
          mobile: null,
        },
      },
      {
        key: 'damage',
        text: {
          desktop: 'shared.asIs.my.banner.noMajorAccidentDesktop',
          mobile: 'shared.asIs.my.banner.noMajorAccidentMobile',
        },
        icon: {
          desktop: NoAccidentsIcon,
          mobile: null,
        },
      },
    ],
    // linkUrl: URL_CONFIG({ region: 'my', lang, path: 'carro-certified' }).formatted,
    linkUrl: '/',
  },
  my: {
    sectionTitle: 'shared.asIs.my.banner.sectionTitle',
    sectionTitleMobile: 'shared.asIs.my.banner.sectionTitleMobile',
    title: 'shared.asIs.my.banner.title',
    subTitle: {
      desktop: 'shared.asIs.my.banner.subTitle',
      mobile: 'shared.asIs.my.banner.subTitleMobile',
      tablet: 'shared.asIs.my.banner.subTitleTablet',
    },
    extraInfo: {
      desktop: 'shared.asIs.my.banner.extraInfo',
      mobile: 'shared.asIs.my.banner.extraInfoMobile',
      tablet: 'shared.asIs.my.banner.extraInfoTablet',
    },
    body: [
      {
        key: 'inspection',
        text: {
          desktop: 'shared.asIs.my.banner.pointInspectionDesktop',
          mobile: 'shared.asIs.my.banner.pointInspectionMobile',
        },
        icon: {
          desktop: InspectionIcon,
          mobile: null,
        },
      },
      {
        key: 'damage',
        text: {
          desktop: 'shared.asIs.my.banner.noMajorAccidentDesktop',
          mobile: 'shared.asIs.my.banner.noMajorAccidentMobile',
        },
        icon: {
          desktop: NoAccidentsIcon,
          mobile: null,
        },
      },
    ],
    // linkUrl: URL_CONFIG({ region: 'my', lang, path: 'carro-certified' }).formatted,
    linkUrl: '/',
  },
  jp: {
    sectionTitle: 'shared.asIs.my.banner.sectionTitle',
    sectionTitleMobile: 'shared.asIs.my.banner.sectionTitleMobile',
    title: 'shared.asIs.my.banner.title',
    subTitle: {
      desktop: 'shared.asIs.my.banner.subTitle',
      mobile: 'shared.asIs.my.banner.subTitleMobile',
      tablet: 'shared.asIs.my.banner.subTitleTablet',
    },
    extraInfo: {
      desktop: 'shared.asIs.my.banner.extraInfo',
      mobile: 'shared.asIs.my.banner.extraInfoMobile',
      tablet: 'shared.asIs.my.banner.extraInfoTablet',
    },
    body: [
      {
        key: 'inspection',
        text: {
          desktop: 'shared.asIs.my.banner.pointInspectionDesktop',
          mobile: 'shared.asIs.my.banner.pointInspectionMobile',
        },
        icon: {
          desktop: InspectionIcon,
          mobile: null,
        },
      },
      {
        key: 'damage',
        text: {
          desktop: 'shared.asIs.my.banner.noMajorAccidentDesktop',
          mobile: 'shared.asIs.my.banner.noMajorAccidentMobile',
        },
        icon: {
          desktop: NoAccidentsIcon,
          mobile: null,
        },
      },
    ],
    // linkUrl: URL_CONFIG({ region: 'my', lang, path: 'carro-certified' }).formatted,
    linkUrl: '/',
  },
  hk: {
    sectionTitle: 'shared.asIs.my.banner.sectionTitle',
    sectionTitleMobile: 'shared.asIs.my.banner.sectionTitleMobile',
    title: 'shared.asIs.my.banner.title',
    subTitle: {
      desktop: 'shared.asIs.my.banner.subTitle',
      mobile: 'shared.asIs.my.banner.subTitleMobile',
      tablet: 'shared.asIs.my.banner.subTitleTablet',
    },
    extraInfo: {
      desktop: 'shared.asIs.my.banner.extraInfo',
      mobile: 'shared.asIs.my.banner.extraInfoMobile',
      tablet: 'shared.asIs.my.banner.extraInfoTablet',
    },
    body: [
      {
        key: 'inspection',
        text: {
          desktop: 'shared.asIs.my.banner.pointInspectionDesktop',
          mobile: 'shared.asIs.my.banner.pointInspectionMobile',
        },
        icon: {
          desktop: InspectionIcon,
          mobile: null,
        },
      },
      {
        key: 'damage',
        text: {
          desktop: 'shared.asIs.my.banner.noMajorAccidentDesktop',
          mobile: 'shared.asIs.my.banner.noMajorAccidentMobile',
        },
        icon: {
          desktop: NoAccidentsIcon,
          mobile: null,
        },
      },
    ],
    // linkUrl: URL_CONFIG({ region: 'my', lang, path: 'carro-certified' }).formatted,
    linkUrl: '/',
  },
});
